exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-table-container[data-v-3fd336c3] {\n  max-height: 600px;\n}\n.service-table-container.with-scroll[data-v-3fd336c3] {\n  overflow-y: scroll;\n}\n.actions-column[data-v-3fd336c3] {\n  width: 100px;\n}\n.icon-style[data-v-3fd336c3] {\n  color: white;\n}\n", ""]);

// exports
